import { useQuery } from '@tanstack/react-query';
import {
  getOrganisationUserDetails,
  UserDetailDto,
} from '../api/userManagementApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { userKeys } from './userKeys';

export function useUser(userId: string | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery<UserDetailDto | null, Error>({
    queryKey: userKeys.detail(userId || ''),
    queryFn: async () => {
      if (!userId) {
        return null;
      }

      const result = await getOrganisationUserDetails(userId);
      return result.user || null;
    },
    enabled: isAuthenticated && !!userId,
  });
}
